import {getNextWizardSteps} from "./wizardLogicOld";

export const LEAD_WIZARD_GROUP_TYPES = {
  group: "group",
  filter: "filter",
  custom: "custom",
  inputs: "inputs",
  contact: "contact",
  appointment: "appointment",
  review: "review",
  success: "success",
}

/**
 * this returns new wizard steps depending on the current selection
 * @param wizardActiveItem {wizardItemInterface}
 * @param currentStep {number}
 * @param wizardSelectedValues {object}
 * @returns {object}
 */
export const getLeadFormSteps = (wizardActiveItem, currentStep, wizardSelectedValues) => {
  const wizardSteps = getNextWizardSteps(wizardActiveItem, currentStep, wizardSelectedValues);
  // console.log("wizardSteps", wizardSteps);
  let leadFormSteps = [];
  wizardSteps.forEach(step => {
    if (step.stepGroups.length && step.stepGroups[0].leadStep) {
      let existingLeadStepObject = leadFormSteps.find(leadStepObject => {
        return leadStepObject.leadStepName === step.stepGroups[0].leadStep
      });
      if (!existingLeadStepObject) {
        existingLeadStepObject = {
          leadStepName: step.stepGroups[0].leadStep,
          leadStepUrl: step.stepGroups[0].leadStepUrl,
          leadSubSteps: []
        }
        leadFormSteps.push(existingLeadStepObject);
      }
      existingLeadStepObject.leadSubSteps.push({
        stepIndex: step.stepIndex,
        wizardGroup: step.stepGroups[0], // not needed for now
      });
    }
  })
  // const leadFormSteps = wizardSteps.reduce((total, step) => {
  //   if (step.stepGroups.length && step.stepGroups[0].leadStep && !total.includes(step.stepGroups[0].leadStep)) {
  //     total.push(step.stepGroups[0].leadStep)
  //   }
  //   return total
  // }, []);
  return leadFormSteps
}

/**
 * this returns lowercased url
 * @param leadStepName {string}
 * @returns {string}
 */
export const getUrlLeadStepName = (leadStepName = "") => {
  if (!leadStepName) {
    return ""
  }
  return leadStepName.toLowerCase().replace(/ /g,"-")
}
